import { ApiService } from '~/service/service.api';
import { PerfumerImportDto } from '~/shared/dto/admin/perfumer.dto';
import { PerfumerId } from '~/shared/dto/id';
import { Model } from '~/shared/service/service.base';
import { ImportModel } from './model.import';

type PerfumerRowType = Omit<InstanceType<typeof PerfumerImportDto>, 'id'> & {
	perfumerId: PerfumerId;
};

@Model()
export class PerfumerImportModel extends ImportModel<PerfumerImportDto> {
	constructor(api: ApiService) {
		super(PerfumerImportDto, api.perfumerImport.bind(api));
	}

	getItemFromRow(row: PerfumerRowType): PerfumerImportDto {
		return {
			id: this.parseNumber(row.perfumerId) as PerfumerId,
			name: row.name,
			description: row.description,
			company: row.company,
			active: this.parseBoolean(row.active),
		};
	}

	downloadTemplate = () => {
		const example: PerfumerRowType = {
			perfumerId: 46,
			name: 'Example Perfumer',
			description: 'A short description',
			company: 'Example Company',
			active: true,
		};

		this.buildAndDownloadCSV('perfumer-import-template.csv', example);
	};
}
